export enum LastMostOrderedArticleType {
  MOST = 'MOST',
  LAST = 'LAST',
}
